import React from 'react';

import 'src/components/Pagination/Pagination.scss';

export const Pagination: React.FC = (props) => {
    return (
        <div className="ais-Pagination pagePagination">
            <ul className="ais-Pagination-list">{props.children}</ul>
        </div>
    );
};
